import { Clock, MapPin, Phone } from 'lucide-react'

interface Office {
	id: string
	phoneNumber: string | null
	address: string | null
	schedule: string | null
	name: string | null
}
export default function AdminOffices(props: { offices: Office[] }) {
	const { offices } = props

	return (
		<>
			<div className="mx-auto grid justify-center gap-4 sm:grid-cols-2 md:max-w-[64rem] md:grid-cols-3">
				{offices?.map(office => (
					<>
						<div
							key={office.id}
							className="relative overflow-hidden rounded-lg border bg-background p-2"
						>
							<div className="flex h-[200px] flex-col justify-between rounded-md p-4">
								<div className="space-y-2">
									<h3 className="line-clamp-2 text-sm font-bold">
										{office.name}
									</h3>
									<div className="flex items-center">
										<MapPin className="h-4 w-4 shrink-0 text-gray-400" />

										<a
											href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(office.address || '')}`}
											target="_blank"
											rel="noopener noreferrer"
											className="ml-2 line-clamp-3 text-sm font-semibold text-gray-800 hover:text-amber-700 hover:underline"
										>
											{office.address}
										</a>
									</div>

									{office.phoneNumber && (
										<div className="flex items-center">
											<Phone className="h-4 w-4 shrink-0 text-gray-400" />
											<a
												href={`tel:${office.phoneNumber.replace(/\s+/g, '')}`}
												className="ml-2 line-clamp-3 text-sm font-semibold text-gray-800 hover:text-amber-700 hover:underline"
											>
												{office.phoneNumber}
											</a>
										</div>
									)}
									{office.schedule && (
										<div className="flex items-center">
											<Clock className="h-4 w-4 shrink-0 text-gray-400" />
											<p className="ml-2 line-clamp-2 text-sm font-semibold text-gray-800">
												{office.schedule}
											</p>
										</div>
									)}
								</div>
							</div>
						</div>
					</>
				))}
			</div>
		</>
	)
}
